import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MsgStatus } from 'src/lib/fliko/models/integrations/sendDataBase.data';
import { EmailQueueData } from 'src/lib/fliko/models/messageQueue/email.data';
import { Contact } from 'src/lib/fliko/models/person/contact.data';
import { ContactsService } from 'src/app/view/estate-view/services/contacts.service';
import { DatabaseService } from './database.service';

@Injectable({
  providedIn: 'root'
})
export class SendEmailService {
  constructor(
    private dbSrv: DatabaseService,
    private contactService: ContactsService
  ) {}

  /**
   * @path /sendEmailQueue/
   * @key id
   */
  private get sendEmailQueue() {
    return this.dbSrv.commonFactory.getCollection<EmailQueueData>('sendEmailQueue');
  }

  private sendEmailQueueByEstateId = (estateId: string) =>
    this.dbSrv.commonFactory.getCollectionReadOnly<EmailQueueData>('sendEmailQueue', {
      by: { child: 'estateId' },
      equalTo: estateId
    });

  public sendEmail(email: EmailQueueData): Promise<void> {
    return this.sendEmailQueue.setElement(email.id, email);
  }

  public async cancelPendingEmails(estateId: string, key: keyof EmailQueueData['additionalData'], value: string): Promise<void> {
    const emails: EmailQueueData[] = await this.sendEmailQueueByEstateId(estateId).onceList();
    const promises: Promise<void>[] = [];

    emails.forEach((email) => {
      if (email.status == MsgStatus.PENDING && email.additionalData[key] == value) {
        promises.push(this.sendEmailQueue.updateElement(email.id, { status: MsgStatus.CANCELED }));
      }
    });

    await Promise.all(promises);
  }

  public getEstateSender$(): Observable<Contact | null> {
    return this.contactService.getContacts$().pipe(
      map((contacts) => {
        let estateContact = contacts.find((c) => c.isEmailContact && c.email);
        if (!estateContact) estateContact = contacts.find((c) => c.isAdministrator && c.email);
        return estateContact ? { email: estateContact.email!, phone: estateContact.phone ?? '' } : null;
      })
    );
  }
}
